<template>
  <div id="app" data-app :class="{ 'has-update': showOutdatedBanner }">
    <transition name="slide-down">
      <BaseBannerFixed v-if="showOutdatedBanner">
        <template slot="content">
          <p class="base-banner-fixed__text">{{ $t('banner') }}</p>
          <BaseLink class="base-banner-fixed__link" is-small @click.native="reloadPage">
            {{ $t('actions.refresh') }}
          </BaseLink>
          <!--<BaseLink class="base-banner-fixed__link" href="https://www.aloha.app/" is-small target-blank>Consulter les nouveautés</BaseLink>-->
        </template>
      </BaseBannerFixed>
      <BaseBannerFixed v-if="showMaintenanceBanner" @close="closeBanner">
        <!-- Use Platform props to display the maintenance platform(s) -->
        <template slot="content">{{ $t('platform-maintenance-banner', { platform: '' }) }} </template>
      </BaseBannerFixed>
    </transition>

    <router-view />
  </div>
</template>

<script>
import BaseLink from '@/components/base/BaseLink';
import BaseBannerFixed from '@/components/base/BaseBannerFixed';
import { mapGetters } from 'vuex';
import { setDocumentLang, setDocumentTitle } from '@/util/i18n/document';

export default {
  components: {
    BaseLink,
    BaseBannerFixed,
  },
  data() {
    return {
      // Used to control the visibility of the maintenance banner, if there is one
      showMaintenanceBanner: false,
    };
  },
  computed: {
    ...mapGetters('appVersionDetector', ['versionOutdated']),
    showOutdatedBanner() {
      return this.$route && !!!this.$route.meta.public && this.versionOutdated;
    },
  },
  methods: {
    // A Vue handler, not an inline onclick attribute: the desktop app's
    // Content-Security-Policy blocks inline event handlers.
    reloadPage() {
      window.location.reload();
    },
    closeBanner() {
      this.showMaintenanceBanner = false;
      localStorage.setItem('maintenanceBannerShown', 'true'); // Mark the banner as shown
    },
    // This method can be used to show the maintenance banner depdending on localStorage
    // Use this to show the banner only once per session or until the user closes it
    updateShowMaintenanceBanner() {
      const bannerShown = localStorage.getItem('maintenanceBannerShown');
      if (!bannerShown) {
        this.showMaintenanceBanner = true; // Show the banner if it hasn't been shown yet
      }
    },
  },
  mounted() {
    this.$watch(
      '$i18n.locale',
      (locale) => {
        setDocumentTitle(this.$route.meta.title);
        setDocumentLang(locale);
      },
      { immediate: true },
    );
  },
};
</script>

<style lang="scss">
@import 'assets/styles/global';
</style>
